import { IconPen, IconPlusRounded, IconTrash } from "@aksara-ui/icons";
import {
  Box,
  Button,
  Card,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Text,
  theme,
} from "@aksara-ui/react";
import { InputSearchbox } from "components/Form/InputSearchbox";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { getAllTenants } from "redux/actions/tenant";
import styled from "styled-components";
import { TenantConfirmModal, TenantFormModal } from "./components";
import { setModalConfirmationOpen, setModalFormOpen } from "redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 20px;
`;

const TenantsContent: React.FC = () => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 576 });

  const { appUrl, isLoading, isModalFormOpen, isModalConfirmationOpen } =
    useSelector((state: any) => state.globalReducer);
  const { tenants } = useSelector((state: any) => state.tenantReducer);

  const [selectedTenantId, setSelectedTenantId] = useState("");

  const handleOpenFormModal = (tenantId: string = "") => {
    dispatch(setModalFormOpen(true) as any);
    setSelectedTenantId(tenantId);
  };

  const handleCloseFormModal = () => {
    dispatch(setModalFormOpen(false) as any);
    setSelectedTenantId("");
  };

  const handleOpenConfirmModal = (tenantId: string) => {
    dispatch(setModalConfirmationOpen(true) as any);
    setSelectedTenantId(tenantId);
  };

  const handleCloseConfirmModal = () => {
    dispatch(setModalConfirmationOpen(false) as any);
    setSelectedTenantId("");
  };

  useEffect(() => {
    dispatch(getAllTenants() as any);
  }, [dispatch]);

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper
        display={"flex"}
        flexDirection={"column"}
        style={{ gap: 20 }}
      >
        <Box display={"flex"}>
          <Text scale={[500, 600]} fontWeight={700}>
            Tenant Management
          </Text>
        </Box>

        <Box
          display={"flex"}
          justifyContent={"space-between"}
          style={{ gap: isMobile ? 10 : 20 }}
        >
          <InputSearchbox
            autoComplete="off"
            name="textDummy"
            placeholder="Search..."
            size={32}
            // onChange={handleSearchChange}
            // onClearButton={handleClearSearchChange}
          />

          <Stack display={"flex"} style={{ gap: 10 }}>
            <Button
              variant={"primary"}
              borderRadius={10}
              style={{ fontWeight: 600 }}
              icon={IconPlusRounded}
              iconPosition={"left"}
              size={32}
              onClick={() => handleOpenFormModal()}
            >
              Add Tenant
            </Button>
          </Stack>
        </Box>
      </HeaderWrapper>

      <Card maxHeight={"100%"} overflow={"auto"} elevation={2}>
        <Table>
          <TableHead
            position={"sticky"}
            top={0}
            backgroundColor={theme.colors.grey02}
          >
            <TableHeadRow>
              <TableHeadCell>Name</TableHeadCell>
              <TableHeadCell>Logo</TableHeadCell>
              <TableHeadCell>Action</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={3} />
            ) : !tenants.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={3} textAlign={"center"}>
                  No data available in table
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              tenants.map((tenant: any) => {
                return (
                  <TableBodyRow key={tenant.id}>
                    <TableBodyCell>{tenant.name}</TableBodyCell>
                    <TableBodyCell>
                      {tenant.logo ? (
                        <LazyLoadImage
                          key={tenant.id}
                          src={`${appUrl}/storage/${tenant.logo}`}
                          alt="tenant-logo"
                          width={100}
                          style={{ borderRadius: 10 }}
                          effect="blur"
                        />
                      ) : (
                        ""
                      )}
                    </TableBodyCell>
                    <TableBodyCell>
                      <IconButton
                        onClick={() => handleOpenFormModal(tenant.id)}
                      >
                        <IconPen fill={theme.colors.green06} />
                      </IconButton>
                      <IconButton
                        onClick={() => handleOpenConfirmModal(tenant.id)}
                      >
                        <IconTrash fill={theme.colors.red06} />
                      </IconButton>
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>

      <TenantFormModal
        tenantId={selectedTenantId}
        isOpen={isModalFormOpen}
        onClose={() => handleCloseFormModal()}
      />

      <TenantConfirmModal
        tenantId={selectedTenantId}
        isOpen={isModalConfirmationOpen}
        onClose={() => handleCloseConfirmModal()}
      />
    </Box>
  );
};

export default TenantsContent;
